import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  id: number
  removeProject: (id: number) => void
}

export const Actions = ({ id, removeProject }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative
            type="secondary"
            aria-label="Project popover menu button"
            iconName="ellipsis"
          />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          <PopoverMenu.TouchableOption
            danger
            title={i18n.t('finance.contacts.contact_details.projects.unlink_project')}
            onClick={() => {
              track(trackingEvents.projectManagement.clients.list.clientListProjectUnlink)
              removeProject(id)
            }}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
      <Button.Router
        type="secondary"
        to={navigation.projects.id.fullPath({ id })}
        onClick={() => {
          track(trackingEvents.projectManagement.clients.list.goToProject)
        }}
        iconName="arrow-right"
      />
    </Box>
  )
}
